import { useMemo } from "react";

import classNames from "classnames";
import sortBy from "lodash/sortBy";

import { useTranslation } from "components/i18n/source";
import { Link, Text } from "components/ui/source";

import { UpgradeService } from "types/graphql";

import IconText from "../../IconText";
import { getUpgradeConfig } from "../getUpgradesConfig";

import styles from "./TopUpgrades.module.scss";

interface Props {
  upgrades: UpgradeService[];
  upgradeCount?: number;
  onSeeAll?: () => void;
  className?: string;
}

export default function TopUpgrades({
  className,
  upgrades,
  upgradeCount = 2,
  onSeeAll,
}: Props) {
  const { t } = useTranslation();
  const upgradeElements = useMemo(
    () =>
      sortBy(upgrades, "type")
        ?.slice(0, upgradeCount)
        .map((u, index) => (
          <div key={u.type + index} data-testid="top-upgrade-item">
            <IconText
              Icon={getUpgradeConfig(u, t).Icon}
              title={getUpgradeConfig(u, t).titleTranslateKey}
              titleTextProps={{ className: styles.upgradeTitle }}
            />
            <div className={styles.upgradePrice}>
              {getUpgradeConfig(u, t).price}
            </div>
          </div>
        )),
    [upgrades, upgradeCount, t],
  );

  if (!upgrades || !upgrades.length) return null;

  return (
    <div className={classNames(className, styles.container)}>
      <Text
        className={styles.title}
        types={["caption1"]}
        translateKey="listing:intro.roomUpgrades"
      />
      <div className={styles.upgradeContainer}>{upgradeElements}</div>
      <Link
        className={styles.link}
        textElement="span"
        textTypes={["caption1", "underline"]}
        translateKey="listing:intro.seeAllUpgrades"
        onClick={onSeeAll}
        inline
        underline
      />
    </div>
  );
}
